<script lang="ts">

    export let justifyContent: string = 'flex-end';

</script>

<div class="container" style="justify-content: {justifyContent}">
    <slot></slot>
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        align-items: center;
        min-height: 50px;
        width: 100%;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 6px;
    }
</style>